// extracted by mini-css-extract-plugin
export default {"title":"forms_title__lkBWb","gender":"forms_gender__w0dna","genderBtn":"forms_genderBtn__c0uH9","removeIcon":"forms_removeIcon__hEFXA","removeBtn":"forms_removeBtn__s7EXw"};